import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Zap } from 'lucide-react';
import Button from '../ui/Button';
import { ROUTES, NAV_ITEMS } from '../../utils/constants';

const Navbar = () => {
  const location = useLocation();
  const isHome = location.pathname === ROUTES.HOME;

  const renderNavItems = () => (
    <>
      {NAV_ITEMS.map((item) => (
        isHome ? (
          <Button key={item.name} variant="ghost" as="a" href={item.href}>
            {item.name}
          </Button>
        ) : (
          <Link key={item.name} to={`/${item.href}`}>
            <Button variant="ghost">{item.name}</Button>
          </Link>
        )
      ))}
      <Button variant="ghost" as={isHome ? 'a' : Link} href="#demo" to="/#demo">
        See Demo
      </Button>
      <Link to={ROUTES.LOGIN}>
        <Button variant="outline">Sign In</Button>
      </Link>
      <Link to={ROUTES.REGISTER}>
        <Button>Start Free Trial</Button>
      </Link>
    </>
  );

  return (
    <nav className="border-b bg-white/80 backdrop-blur-md fixed w-full z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link to={ROUTES.HOME} className="flex items-center">
            <Zap className="h-8 w-8 text-primary-600" />
            <span className="ml-2 text-xl font-bold bg-gradient-to-r from-primary-600 to-primary-700 text-transparent bg-clip-text">
              LocalFlow
            </span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-6">
            {renderNavItems()}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;